<script>
import Bus from '@/libs/bus';
import {mapActions} from 'vuex';
import {getUrlParameter} from '@/libs/util';

export default {
  data() {
    return {};
  },
  mounted() {
    this.oauth();

    // 需要重新登录跳转
    Bus.$on('login', () => {
      this.$router.push('login');
    });
  },
  methods: {
    ...mapActions([
      'handleWxOAuthLogin'
    ]),
    oauth() {
      if (getUrlParameter('code')) {
        this.handleWxOAuthLogin(getUrlParameter('code'));
      }
    }
  }
}
</script>

<template>
  <div id="app">
    <keep-alive exclude="scanQr">
      <router-view/>
    </keep-alive>
  </div>
</template>

<style lang="stylus">
@import './assets/css/site.css';
@import './assets/icon-font/sdt.css';

a
  -moz-user-focus none;
  -moz-user-select none;
  -webkit-user-select none;
  -webkit-tap-highlight-color rgba(255, 255, 255, 0);

#app
  font-family Avenir, Helvetica, Arial, sans-serif
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  text-align left
  color #2c3e50

.no-data
  display flex
  align-items center
  justify-content center


.no-data .content img
  width 100px
  height 100px
  opacity 0.4

</style>
